module.exports = __webpack_public_path__ + "static/media/abzug_frage.650849a7.jpg";